import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["element"]

  close() {
    $("#modal-holder .modal").modal("hide")
    $('#modal-holder').html('');
  }
}
